import o from "./index179.js";
/* empty css         */
import t from "./index130.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-90ceeac0"]]);
export {
  p as default
};
